import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SaveButton } from '@app/shared/buttons/save-button/save-button';

export interface CommentDialogData {
  title: string;
  comment?: string;
  required?: boolean;
}

@Component({
  selector: 'app-comment-dialog',
  imports: [
    CommonModule,
    MatDialogContent,
    MatDialogActions,
    MatButtonModule,
    SaveButton,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatTooltipModule,
  ],
  templateUrl: './comment-dialog.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./comment-dialog.scss'],
})
export class CommentDialog {
  readonly cdr = inject(ChangeDetectorRef);
  readonly dialogRef = inject(MatDialogRef<CommentDialog>);
  readonly data = inject<CommentDialogData | null>(MAT_DIALOG_DATA);
  comment: string = this.data?.comment || '';

  get isValid() {
    if (this.data?.required) {
      return this.comment.trim().length > 0;
    }
    return true;
  }

  onOk() {
    this.dialogRef.close(this.comment);
  }

  onCancel() {
    this.dialogRef.close();
  }
}
